<template >
  <b-row>
    <b-col lg="12" style="height: 500px">
      <h3>{{ $t("teachers.teachers") }}</h3>
      <hr />
      <b-list-group>
        <b-list-group-item
          class="d-flex"
          v-for="teacher in teachers"
          :key="teacher.id"
          button
        >
          <span class="mr-1">
            <b-form-checkbox
              v-model="eduProgramTeachers"
              :value="teacher.id"
              
              class="custom-control-primary"
            >
            </b-form-checkbox>
          </span>
          <span>{{ teacher.full_name }}</span>
        </b-list-group-item>
      </b-list-group>
      <b-spinner v-if="load" type="grow" label="Loading..."  class="loading" />
    </b-col>

    <hr />

    <b-col lg="6">
      <b-button block variant="primary" @click="submit()">
        <i class="fa fa-plus" /> {{ $t("site.save") }}
      </b-button>
    </b-col>
    <b-col lg="6">
      <b-button block  @click="goToTable()" variant="success">
        <i class="fas fa-ban"></i> {{ $t("site.cancel") }}
      </b-button>
    </b-col>
  </b-row>
</template>

<script>
import UsersController from "@/Controllers/UsersController";
import EduProgramsController from "@/Controllers/EduProgramsController";
import { forEach } from 'postcss-rtl/lib/affected-props';
let eduCTR = new EduProgramsController();
export default {
  data() {
    return {
      teachers: [],
      eduProgramTeachers: [],
      courses: [],
      showCourses: false,
      teachersCourses: [],
      courseSelected: [],
      teacherSelected: {},
      load: false,
      data: [],
    };
  },
  created() {
    this.load = true;
    new UsersController().GetAll({ type: "teacher" }).then((res) => {
      this.teachers = res;
      this.load = false;
    });
    eduCTR.GetUsers(this.$route.params.eduProgramId).then((user) => {
      this.eduProgramTeachers = user.teachers.map((item) => item.id);
    });
    eduCTR.GetTeachersCourses(this.$route.params.eduProgramId).then((res) => {
      this.teachersCourses = res;
    });
    new EduProgramsController()
      .getCourseByProgram(this.$route.params.eduProgramId)
      .then((res) => {
        this.courses = res.filter((a) => a.flixable == 0);
      });
  },
  methods: {
     

       goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async submit() {
      const data=[]
      this.eduProgramTeachers.forEach(element => {
        data.push({ teacherId:element });
      });
      
      eduCTR.SaveTeachers(this.$route.params.eduProgramId, {
        data,is_course:1
      });
    },
  },
};
</script>

<style>
</style>